// extracted by mini-css-extract-plugin
export default {"MealEntry":"MealEntry_MealEntry__QC+AP","MealHeader":"MealEntry_MealHeader__Cs1ZZ"};